import { Container, Row, Col } from "react-bootstrap";
import PatientForResumeRow from "../PatientForResumeRow";

const PatientForResumeList = ({patients= []}) => {
  return (
    <Row className="pt-4">
      <Col>
        {
          patients.map((p) => (
            <PatientForResumeRow name={p.name} id={p.id}/>
          ))
        }
      </Col>
    </Row>
  );
};

export default PatientForResumeList;
